var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { SortDirection, Expression, DataKind, ExprTag, Query, QueryChangeAction, ConditionPart } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { ExpressionRenderer } from './expression_renderer';
import { PopupMenu } from '../../../utils/popup_menu';
import { QueryPanel } from '../../query_panel';
import { QPEditablePart } from '../../../types/qp_editable_part';
var SubQueryExpressionRenderer = /** @class */ (function (_super) {
    __extends(SubQueryExpressionRenderer, _super);
    function SubQueryExpressionRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubQueryExpressionRenderer.prototype.renderEditor = function () {
        this.dialogBlockBody = domel('div')
            .addClass("kfrm-form")
            //.setStyle('height', '100%')
            .toDOM();
        this.createEntitiesMenu();
        this.renderColumnBlock();
        this.renderQueryPanelBlock();
    };
    SubQueryExpressionRenderer.prototype.isEditable = function () {
        return _super.prototype.isEditable.call(this)
            && ((this.panel.options.editableParts & QPEditablePart.Value) === QPEditablePart.Value);
    };
    SubQueryExpressionRenderer.prototype.setValue = function (value, silent) {
        if (value instanceof Query) {
            this.expression.subQuery = value;
            if (!silent) {
                this.expression.getParent().fireChangedEvent(ConditionPart.Value);
            }
        }
    };
    SubQueryExpressionRenderer.prototype.createEntitiesMenu = function () {
        var model = this.getContext().getModel();
        var exprType = this.expression.dataType;
        this.colEntitiesList = model.getEntitiesTreeWithFilter(function (ent, attr) {
            if (attr) {
                return attr.useInConditions && attr.dataType === exprType;
            }
            else {
                //if it's entity
                return ent.attributes && ent.useInConditions;
            }
        });
        if (!model || model.isEmpty())
            return null;
        var menuId = this.element.getAttribute('data-id');
        if (menuId) {
            menuId += '-SubColumnMenu';
        }
        var options = {
            items: this.colEntitiesList,
            adjustHeight: this.panel.options.adjustEntitiesMenuHeight,
            id: menuId,
            isSubQuery: true,
            domWriteItemsId: this.panel.options.domWriteItemsId
        };
        dataUtils.assign(options, this.panel.options.menuOptions);
        this.colEntitiesMenu = new PopupMenu(options);
    };
    SubQueryExpressionRenderer.prototype.renderColumnBlock = function () {
        var _this = this;
        this.columnBlock = domel('div', this.dialogBlockBody)
            .addClass("kfrm-field")
            .addChild('label', function (b) { return b
            .addText(i18n.getText('SubQueryColumnTitle')); })
            .addChild('a', function (b) { return _this.columnElement = b
            .attr('href', 'javascript:void(0)')
            .on('click', function (e) {
            _this.colEntitiesMenu.showMenu({
                anchor: _this.columnElement,
                selectedIds: null,
                itemSelectedCallback: function (data, items) {
                    var attrId = data.id;
                    _this.setResultAttributeId(attrId);
                    return false;
                }
            });
        })
            .toDOM(); })
            .toDOM();
    };
    SubQueryExpressionRenderer.prototype.getEmptyText = function () {
        return this.panel.options.emptyTextValue || i18n.getText('MsgSubQueryValue');
    };
    SubQueryExpressionRenderer.prototype.renderQueryPanelBlock = function () {
        var parentEl = domel('div', this.dialogBlockBody)
            .addClass("kfrm-field")
            .addChild('label', function (b) { return b
            .addText(i18n.getText('SubQueryQueryPanelCaption')); })
            .toDOM();
        this.queryPanelBlock =
            domel('div', parentEl)
                .toDOM();
        var qpId = this.element.getAttribute('data-id');
        if (qpId) {
            this.queryPanelBlock.id = qpId + '-SubQueryPanel';
        }
    };
    SubQueryExpressionRenderer.prototype.setResultAttributeId = function (attrId) {
        var attrObj = this.getContext().getModel().getAttributeById(attrId);
        if (attrObj) {
            var subQuery = this.getSubQuery();
            var cols = subQuery.getColumns();
            var column = void 0;
            if (cols.length > 0) {
                column = cols[0];
                column.expr.setValue(attrId);
                column.expr.dataType = attrObj.dataType;
                column.fireChangedEvent();
            }
            else {
                column = subQuery.createColumn();
                column.sorting = SortDirection.None;
                column.sortIndex = -1;
                var expr = new Expression(column);
                expr.setValue(attrId);
                expr.tag = ExprTag.EntityAttribute;
                expr.kind = DataKind.Attribute;
                expr.dataType = attrObj.dataType;
                column.expr = expr;
                cols.push(column);
                subQuery.fireColumnsChangedEvent(QueryChangeAction.Add, column);
            }
            this.columnElement.innerText = this.getAttributeText(attrObj);
        }
    };
    SubQueryExpressionRenderer.prototype.getSubQuery = function () {
        return this.queryPanel.getQuery();
    };
    SubQueryExpressionRenderer.prototype.getAttributeText = function (attribute) {
        if (!attribute)
            return i18n.getText('SubQueryEmptyColumn');
        var attrText = i18n.getText('Attributes', attribute.id);
        if (!attrText)
            attrText = attribute.caption;
        var format = this.panel.options.attrElementFormat;
        if (!format)
            return attrText;
        var result = format.replace(new RegExp("{attr}", 'g'), attrText);
        var entityPath = this.getContext()
            .getModel()
            .getFullEntityPathByAttr(attribute.id, '.');
        return result.replace(new RegExp("{entity}", 'g'), entityPath);
    };
    SubQueryExpressionRenderer.prototype.showEditor = function () {
        var _this = this;
        var parentPanel = this.panel;
        var context = this.getContext();
        this.queryPanelBlock.innerHTML = "";
        var subQuery = context.createQuery();
        if (this.expression.subQuery) {
            subQuery.loadFromData(this.expression.subQuery.toJSONData());
        }
        var subOptions = dataUtils.assign({}, parentPanel.options);
        subOptions.isSubQuery = true;
        subOptions.showAddRow = true;
        subOptions.menuContainer = document.body;
        subOptions.menuOptions.isSubQuery = true;
        subOptions.entitiesListFilter = function (listItems, listOptions) {
            if (parentPanel.options.entitiesListFilter) {
                var subQueryPanelListOptions = listOptions || {};
                subQueryPanelListOptions.isSubQuery = true;
                parentPanel.options.entitiesListFilter(listItems, subQueryPanelListOptions);
            }
        };
        this.queryPanel = new QueryPanel(this.queryPanelBlock, subQuery);
        this.queryPanel.init(this.panel.getContext(), subOptions);
        var attrId = null;
        var cols = subQuery.getColumns();
        ;
        if (cols.length == 0) {
            var condition = this.expression.getParent();
            if (condition.expressions.length > 0) {
                var attrExpr = condition.expressions[0];
                attrId = (attrExpr.tag == ExprTag.EntityAttribute
                    || attrExpr.kind == DataKind.Attribute) ? attrExpr.value : null;
            }
        }
        else {
            attrId = cols[0].expr.value;
        }
        if (attrId) {
            this.setResultAttributeId(attrId);
        }
        else {
            this.columnElement.innerText = i18n.getText("SubQueryEmptyColumn");
        }
        this.queryPanel.refresh();
        var rootCondEl = this.queryPanelBlock.querySelector('.eqjs-qp-conditions-root');
        if (rootCondEl) {
            rootCondEl.style.minHeight = '100px';
        }
        var dialogService = this.panel
            .getContext()
            .getServices()
            .getDialogService();
        dialogService.open({
            title: i18n.getText('SubQueryDialogTitle'),
            body: this.dialogBlockBody,
            width: this.panel.options.subQueryDialogWidth,
            //height: this.panel.options.subQueryDialogHeight,
            closable: true,
            cancelable: true,
            onSubmit: function () {
                var value = _this.queryPanel.getQuery();
                // validate subquery
                if (value.tryValidate({ checkExpressions: true })) {
                    _this.setValue(value);
                    return true;
                }
                return false;
            }
        });
    };
    SubQueryExpressionRenderer.prototype.closeEditor = function () {
    };
    return SubQueryExpressionRenderer;
}(ExpressionRenderer));
export { SubQueryExpressionRenderer };
//# sourceMappingURL=subquery_expression_renderer.js.map